import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (
        action.entityType === 'inbox' &&
        action.payload &&
        action.payload.length
      ) {
        return action.payload.reduce((acc, curr) => {
          acc[curr.contact_id] = {}
          if (
            state[curr.contact_id] &&
            state[curr.contact_id].value !== curr.last_interaction
          ) {
            acc[curr.contact_id].unequal = state[curr.contact_id].unequal
              ? state[curr.contact_id].unequal + 1
              : 1
          }
          acc[curr.contact_id].value = curr.last_interaction
          acc[curr.contact_id].previousValue =
            (state[curr.contact_id] && state[curr.contact_id].value) || ''
          return acc
        }, {})
      }
      return state
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'inbox' && action.payload && action.payload.contact_id) {
        // console.log('hits first if')
        if (state[action.payload.contact_id]) {
          // console.log('hits 2nd if')
          return {
            ...state,
            [action.payload.contact_id]: {
              previousValue: state[action.payload.contact_id].value || '',
              value: action.payload.last_interaction,
              unequal: 0,
            },
          }
        }
        return state
      }
      return state
    default:
      return state
  }
}
